import React, { useReducer, useState, useEffect } from 'react';
import {
  LayoutDashboard,
  Users,
  Blocks,
  Cog,
  Handshake,
  ClipboardList,
  ScrollText,
  UserRoundPlus
} from 'lucide-react';
import { Collapse } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { MenuListNew, MenuListFlat } from '../../../constants/NavBar';
import { AuthConstant, EDIT_ALLOWED_ROLES } from '../../../constants/constant';
import { useMenu } from '../../../context/MenuContext';
import { localStorageKeyName } from '../../../constants/constant';
import { fetchUserRights } from '../../../apis/UserRights';
import { fetchRights } from '../../../utils';

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState
});

const initialState = {
  active: '',
  activeSubmenu: ''
};

const SideBar = () => {
  const dat = new Date();
  const [state, setState] = useReducer(reducer, initialState);

  const [heartBtn, setHeartBtn] = useState();
  const [userMenu, setUserMenu] = useState([]);
  const { initializeMenuList, getMenuList, setAdmins, setMenuList } = useMenu();
  // ── Role-based access ─────────────────────────────────────────────────────
  // Safely read user role from localStorage (returns null if not logged in)
  const userRole = (() => {
    try {
      const raw = localStorage.getItem('userDetails');
      return raw ? JSON.parse(raw)?.role : null;
    } catch {
      return null;
    }
  })();

  // Initialize menu list from context on mount
  useEffect(() => {
    const loadMenu = async () => {
      try {
        const response = await fetchUserRights(userRole);
        const normalized = normalizeMenuListFlat(response || []);
        setUserMenu(normalized);
        setMenuList(response || []);
        // setAdmins(response?.filter((item) => item.is_admin) || []);
        setAdmins(EDIT_ALLOWED_ROLES);
      } catch (err) {
        console.log('Error fetching user rights:', err);
      }
    };
    loadMenu();
  }, [setMenuList, userRole]);

  // export const fetchRights = async () => {
  //   // setIsLoading(true);
  //   try {
  //     const response = await fetchUserRights(userRole);
  //     setUserMenu(normalizeMenuListFlat(response || []));
  //     setMenuList(response || []);
  //   } catch (err) {
  //     console.log('Error fetching user rights:', err);
  //   } finally {
  //     // setIsLoading(false);
  //   }
  // }

  const normalizeMenuListFlat = (menuFlat) =>
    menuFlat.map((parent) => ({
      title: parent.menuName,
      content: (parent.subMenus || []).map((sub) => ({
        ...sub,
        title: sub.menuItemName,
        MenuItemName: sub.menuItemName,
        to: sub.routingKey,
        viewPermission: sub.hasListPermission !== false,
        access: sub.access || []
      }))
    }));

  // const menuItems = normalizeMenuListFlat(getMenuList());

  const getMenuIcon = (item) => {
    if (item.icon) return item.icon;

    const title = (item.title || '').toLowerCase();
    if (title.includes('dashboard')) return <LayoutDashboard className="w-5 h-5" />;
    if (title.includes('master')) return <Cog className="w-5 h-5" />;
    if (title.includes('client')) return <Users className="w-5 h-5" />;
    if (title.includes('installation')) return <Blocks className="w-5 h-5" />;
    if (title.includes('dcr')) return <Handshake className="w-5 h-5" />;
    if (title.includes('issues')) return <ClipboardList className="w-5 h-5" />;
    if (title.includes('amc')) return <ScrollText className="w-5 h-5" />;
    if (title.includes('user')) return <UserRoundPlus className="w-5 h-5" />;
    return <Blocks className="w-5 h-5" />;
  };

  // Set active state on load based on path matches
  useEffect(() => {
    let path = window.location.pathname;
    const cleanPath = path.replace(/^\/|\/$/g, '');

    // Find matching parent and submenu
    userMenu.forEach((parent) => {
      if (parent.content && parent.content.length > 0) {
        parent.content.forEach((subItem) => {
          if (subItem.content && subItem.content.length > 0) {
            subItem.content.forEach((nestedItem) => {
              const cleanItem = nestedItem.to.replace(/^\/|\/$/g, '');
              if (cleanItem === cleanPath || cleanPath.endsWith(cleanItem)) {
                setState({ active: parent.title, activeSubmenu: subItem.MenuItemName });
              }
            });
          } else {
            const cleanItem = subItem.to.replace(/^\/|\/$/g, '');
            if (cleanItem === cleanPath || cleanPath.endsWith(cleanItem)) {
              setState({ active: parent.title });
            }
          }
        });
      }
    });
  }, [window.location.pathname, userMenu]);

  /**
   * Returns true if the current user can see this menu/sub-item.
   * Rules:
   *   - If the item has no `access` array → show it (backward compatible)
   *   - If access includes AuthConstant.ALL (1000) → show to everyone
   *   - Otherwise → show only if userRole is in the access array
   */
  const canAccess = (item) => {
    if (item.hasListPermission === false) return false;
    // if (!item.access || item.access.length === 0) return true;
    // if (item.access.includes(AuthConstant.ALL)) return true;
    // return userRole !== null && item.access.includes(userRole);
    return true;
  };

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: '' });
    }
  };
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: '' });
    }
  };
  // Menu dropdown list End

  /// Path
  let path = window.location.pathname;
  // Make sure we have a clean path to match against data.to
  // e.g., if pathname is "/users" and data.to is "/users", they should match.
  // We'll normalize both when comparing.

  const isMatched = (itemPath) => {
    if (!itemPath) return false;
    // Remove leading/trailing slashes for comparison
    const cleanItem = itemPath.replace(/^\/|\/$/g, '');
    const cleanPath = path.replace(/^\/|\/$/g, '');
    return cleanItem === cleanPath || cleanPath.endsWith(cleanItem);
  };

  return (
    <div className="deznav">
      <div className="deznav-scroll">
        <ul className="metismenu" id="menu">
          {userMenu.filter(canAccess).map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === 'menu-title') {
              return (
                <li className={menuClass} key={index}>
                  {data.title}
                </li>
              );
            } else {
              return (
                <li
                  className={`has-menu ${
                    state.active === data.title || (!data.content && isMatched(data.to))
                      ? 'mm-active'
                      : ''
                  }`}
                  key={index}
                  title={data.title}
                >
                  {data.content && data.content.length > 0 ? (
                    <Link
                      to={'#'}
                      className="has-arrow ai-icon"
                      onClick={() => {
                        handleMenuActive(data.title);
                      }}
                    >
                      <i
                        className="sidebar-icon-wrapper"
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        {getMenuIcon(data)}
                      </i>{' '}
                      <span className="nav-text">{data.title}</span>
                    </Link>
                  ) : (
                    <Link
                      to={data.to}
                      className="ai-icon"
                      onClick={() => {
                        handleMenuActive(data.title);
                      }}
                    >
                      <i
                        className="sidebar-icon-wrapper"
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        {getMenuIcon(data)}
                      </i>{' '}
                      <span className="nav-text">{data.title}</span>
                    </Link>
                  )}
                  {data.content && (
                    <Collapse in={state.active === data.title ? true : false}>
                      <ul className={`${menuClass === 'mm-collapse' ? 'mm-show' : ''}`}>
                        {data.content &&
                          data.content.filter(canAccess).map((data, index) => {
                            return (
                              <li
                                key={index}
                                className={`${
                                  state.activeSubmenu === data.MenuItemName ? 'mm-active' : ''
                                }`}
                              >
                                {data.content && data.content.length > 0 ? (
                                  <>
                                    <Link
                                      to={data.to}
                                      className={data.hasMenu ? 'has-arrow' : ''}
                                      onClick={() => {
                                        handleSubmenuActive(data.MenuItemName);
                                      }}
                                    >
                                      {data.MenuItemName}
                                    </Link>
                                    <Collapse
                                      in={state.activeSubmenu === data.MenuItemName ? true : false}
                                    >
                                      <ul
                                        className={`${
                                          menuClass === 'mm-collapse' ? 'mm-show' : ''
                                        }`}
                                      >
                                        {data.content &&
                                          data.content.map((data, index) => {
                                            return (
                                              <li key={index}>
                                                <Link
                                                  className={`${
                                                    isMatched(data.to) ? 'mm-active' : ''
                                                  }`}
                                                  to={data.to}
                                                >
                                                  {data.title}
                                                </Link>
                                              </li>
                                            );
                                          })}
                                      </ul>
                                    </Collapse>
                                  </>
                                ) : (
                                  <Link
                                    className={`${isMatched(data.to) ? 'mm-active' : ''}`}
                                    to={data.to}
                                  >
                                    {data.MenuItemName}
                                  </Link>
                                )}
                              </li>
                            );
                          })}
                      </ul>
                    </Collapse>
                  )}
                </li>
              );
            }
          })}
        </ul>
        {/* <div className="plus-box">
          <p className="fs-16 font-w500 mb-1">Check your job schedule</p>
          <Link to={'#'} className="text-white fs-26">
            <i className="las la-long-arrow-alt-right" />
          </Link>
        </div> */}
        <div className="copyright">
          <p>
            <strong>Medsky Hospital Admin Dashboard</strong> © {dat.getFullYear()} All Rights
            Reserved
          </p>
          {/* <p>
            Made with{' '}
            <span
              className={`heart ${heartBtn ? 'heart-blast' : ''}`}
              onClick={() => setHeartBtn(!heartBtn)}
            ></span>{' '}
            by Nethaji
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default SideBar;
